export default "__VITE_ASSET__8d__YWvP__"